export const CodeBlock = ({ code, label = "shell", testId }) => (
  <div data-testid={testId} className="border border-border bg-[#0A0A0A] text-zinc-200">
    <div className="flex items-center justify-between px-3 py-1.5 border-b border-white/10">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">{label}</span>
      <div className="flex gap-1.5">
        <span className="h-2 w-2 bg-zinc-700" />
        <span className="h-2 w-2 bg-zinc-700" />
      </div>
    </div>
    <pre className="p-4 overflow-x-auto text-xs leading-relaxed font-mono whitespace-pre-wrap">{code}</pre>
  </div>
);

export const ScoreBar = ({ value, testId }) => (
  <div data-testid={testId} className="h-1 w-full bg-border overflow-hidden">
    <div
      className="h-full transition-[width] duration-500"
      style={{
        width: `${Math.max(2, value)}%`,
        background: value >= 70 ? "hsl(var(--success))" : value >= 45 ? "hsl(var(--warning))" : "hsl(var(--destructive))",
      }}
    />
  </div>
);

export const StatCard = ({ label, value, sub, icon: Icon, testId }) => (
  <div data-testid={testId} className="border border-border p-5 hover:border-primary/50 hover:-translate-y-1 transition-[transform,border-color] duration-200">
    <div className="flex items-start justify-between">
      <p className="overline text-muted-foreground">{label}</p>
      {Icon && <Icon className="h-4 w-4 text-primary" />}
    </div>
    <p className="mt-4 font-display text-3xl font-bold tracking-tighter">{value}</p>
    {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
  </div>
);

export const EmptyState = ({ title, body, action, testId }) => (
  <div data-testid={testId} className="border border-dashed border-border p-10 text-center">
    <p className="font-display text-lg font-bold">{title}</p>
    <p className="mt-2 text-sm text-muted-foreground max-w-md mx-auto">{body}</p>
    {action && <div className="mt-6 flex justify-center">{action}</div>}
  </div>
);
